import graphql__07f7282475045ae4248f from "./__generated__/CityWalkComplete_cityWalk.graphql.js";
import graphql__9255ed80e572bd16f62f from "./__generated__/CityWalkCompleteFinalizeContributionQuery.graphql.js";import { useCallback } from "react";
import { graphql, useFragment, useQueryLoader } from "react-relay";
import { useDispatch } from "react-redux";
import { defineMessages } from "react-intl";

import MapPanelsManager from "../Maps/MapPanel/MapPanelsManager";
import MapPanel from "../Maps/MapPanel/MapPanel";
import MapPanelActions from "../Maps/MapPanel/MapPanelActions";
import Button from "../Buttons/Button";
import { useFormatMessage } from "../Intl/Context";
import { useMapContext } from "../Maps/MapContext";
import { useNavigateTo } from "../Routes/RoutesContext";

import { setCityWalkCurrentWaypoint, setCityWalkActive } from "../../reducers/cityWalks";

const CityWalkComplete = props => {
  const cityWalk = useFragment(CityWalkComplete_cityWalk, props.cityWalk);
  const { slug: participativeModuleSlug } = cityWalk;

  const t = useFormatMessage();
  const cityWalkCompleted = t(intlMessages.cityWalkCompleted);
  const close = t(intlMessages.close);

  const { mapKey } = useMapContext();
  const navigateTo = useNavigateTo();
  const dispatch = useDispatch();

  // Prepare the query loader to reload the `cityWalk.activeContribution` when the close
  // button is clicked.
  const [, loadQuery] = useQueryLoader(CityWalkCompleteFinalizeContributionQuery);

  const handleCloseButtonClicked = useCallback(() => {
    // Force reloading the `cityWalk.activeContribution` field from the server so that
    // it is reset to null when navigating back to the participative module home page,
    // and allows starting a new contribution
    loadQuery({ participativeModuleSlug }, { fetchPolicy: "network-only" });

    dispatch(setCityWalkActive(mapKey, false));
    dispatch(setCityWalkCurrentWaypoint(mapKey, null));
    navigateTo("participativeModule", { participativeModuleSlug });
  }, [dispatch, loadQuery, mapKey, navigateTo, participativeModuleSlug]);

  return (
    <MapPanelsManager>
      <MapPanel
        className="map-city-walk-complete-dialog"
        isToggleable={false}
        isOpen={true}
      >
        <p
          className="box padding-md"
          dangerouslySetInnerHTML={{ __html: cityWalkCompleted }}
        />

        <MapPanelActions>
          <Button
            type="button"
            className="btn btn-block-md btn-primary"
            onClick={handleCloseButtonClicked}
            label={close}
            iconClassName="icon-arrow-right"
            iconPosition="after"
          />
        </MapPanelActions>
      </MapPanel>
    </MapPanelsManager>
  );
};

const CityWalkComplete_cityWalk = graphql__07f7282475045ae4248f;

const CityWalkCompleteFinalizeContributionQuery = graphql__9255ed80e572bd16f62f;

export default CityWalkComplete;

const intlMessages = defineMessages({
  cityWalkCompleted: {
    id: "city_walk.complete.cityWalkCompleted",
    defaultMessage: `
      Nous vous remercions pour votre participation à la balade interactive.
      <br>
      Votre contribution a bien été prise en compte.
    `
  },
  close: {
    id: "city_walk.complete.close",
    defaultMessage: "Fermer"
  }
});
